module.exports = __webpack_public_path__ + "front/img/i2.da5b87ef.png";